module.exports = __webpack_public_path__ + "static/media/cctv.b17a7f5d.png";